exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".formItem-1428e{margin-bottom:0}", ""]);

// Exports
exports.locals = {
	"formItem": "formItem-1428e"
};